function cleanEnv(value: unknown): string {
    return String(value || '')
        .trim()
        .replace(/^['"]|['"]$/g, '')
        .replace(/\/+$/, '');
}

const Backofficebff = cleanEnv(import.meta.env.VITE_BACKOFFICEBFF);
const ApiBaseUrl = cleanEnv(import.meta.env.VITE_APIURL);

/**
 * Controllers live under `{bff}/v1/...` (often ending with `/api`).
 * Hubs are mapped at service root: `{serviceRoot}/hubs/...`.
 *
 * Local (.env.local): use same-origin `/hubs/retro` (Vite proxies to VITE_APIURL).
 * Deployed: `https://boapi.../backofficebff/service/hubs/retro`
 */
function stripApiSuffix(path: string): string {
    if (!path) return '';
    if (path === 'api' || path === '/api') return '';
    return path.replace(/\/api$/i, '');
}

function ensureLeadingSlash(path: string): string {
    if (!path) return '';
    return path.startsWith('/') ? path : `/${path}`;
}

function isLocalApiHost(apiBaseUrl: string): boolean {
    if (!apiBaseUrl) return false;
    try {
        const host = new URL(apiBaseUrl).hostname;
        return host === 'localhost' || host === '127.0.0.1';
    } catch {
        return /localhost|127\.0\.0\.1/i.test(apiBaseUrl);
    }
}

export function getSignalRBaseUrl(): string {
    // Local: relative path so Vite `/hubs` proxy is used (http://localhost:3000/hubs/...)
    if (isLocalApiHost(ApiBaseUrl) && !/^https?:\/\//i.test(Backofficebff)) {
        return '';
    }

    if (/^https?:\/\//i.test(Backofficebff)) {
        return stripApiSuffix(Backofficebff);
    }

    const bffPath = ensureLeadingSlash(Backofficebff);
    const serviceRoot = stripApiSuffix(bffPath);

    if (/^https?:\/\//i.test(ApiBaseUrl)) {
        const origin = new URL(ApiBaseUrl).origin;
        return serviceRoot ? `${origin}${serviceRoot}` : origin;
    }

    return serviceRoot || '';
}

export const SignalRHubUrls = {
    Retro: `${getSignalRBaseUrl()}/hubs/retro`,
    StudioBatchTracking: `${getSignalRBaseUrl()}/hubs/studio-batch-tracking`,
} as const;
